import React, { useState, useEffect, useRef } from 'react';
import TR from './../../Trans';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { Capacitor } from '@capacitor/core';
import Tooltip from '@mui/material/Tooltip';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import AddPlayList from './AddPlayList';
import InfoIcon from '@mui/icons-material/Info';
import FormGroup from '@mui/material/FormGroup';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import { Keyboard } from '@capacitor/keyboard';
import DialogContent from '@mui/material/DialogContent';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import MenuItem from '@mui/material/MenuItem';
import AddSinger from './../dialogs/AddSinger';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import DialogPlayer from '../player/DialogPlayer';
import PitchButtons from '../items/PitchButtons';
import IconButton from '@mui/material/IconButton';
import PositionButtons from '../items/PositionButtons';
import SelectSongPosition from './SelectSongPosition';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import CreatorsDialog from './CreatorsDialog';
import MuvikaService from './../../services/muvika';
import sessionStore from './../../stores/session';
import messageStore from '../../stores/message';
import singersStore from './../../stores/singers';
import settingsStore from '../../stores/settings';
import accountStore from '../../stores/account';
import performanceStore from '../../stores/performance';
import { Views } from './../../enums/enums';
import Link from '@mui/material/Link';
import searchStore from '../../stores/search';
import navigationStore from '../../stores/navigation';
import songbookQueueStore from '../../stores/songbookQueue';

function EditPerformance(props) {

  const singerRef = useRef(null);

  const sessionToken = sessionStore((state) => state.sessionToken);
  const setError = messageStore((state) => state.setError);
  const settings = settingsStore((state) => state.settings);
  const account = accountStore((state) => state.account);
  const addSingerLocally = singersStore((state) => state.addSingerLocally);
  const playQueue = performanceStore((state) => state.playQueue);
  const playLists = performanceStore((state) => state.playLists);
  const isQueueingOn = songbookQueueStore((state) => state.isQueueingOn);
  const editSinger = singersStore((state) => state.editSinger);

  const itemsOnPage = 25;
  const setSearchQuery = searchStore((state) => state.setSearchQuery);
  const goToView = navigationStore((state) => state.goToView);
  const search = searchStore((state) => state.search);
  const setOnlyArtist = searchStore((state) => state.setOnlyArtist);

  const [currentSinger, setCurrentSinger] = useState(props.performance.profile);
  const [currentPitch, setCurrentPitch] = useState(props.performance.pitch);
  const [currentSingerName, setCurrentSingerName] = useState(null);
  const [currentPos, setCurrentPos] = useState(null);
  const [isSelectSongPositionOpen, setIsSelectSongPositionOpen] = useState(false);
  const [currentPlayList, setCurrentPlayList] = useState(null);
  const [isAddPlayListOpen, setIsAddPlayListOpen] = useState(false);
  const [isSongbookQueue, setIsSongbookQueue] = useState(false);

  const dialogRef = useRef(null);

  const handleOpenSelectSongPosition = () => {
    setIsSelectSongPositionOpen(true);
  };

  const handleCloseSelectSongPosition = () => {
    setIsSelectSongPositionOpen(false);
  };

  const handleOpenAddPlayList = () => {
    setIsAddPlayListOpen(true);
  };

  const handleCloseAddPlayList = () => {
    setIsAddPlayListOpen(false);
  };

  useEffect(() => {
    let isManual = false;
    if (props.performance.flags) {
      if (props.performance.flags.includes("manual")) {
        isManual = true;
      }
    }
    if (props.performance.position == 0 || isManual || !settingsStore.getState().settings?.smartq_enabled) {
      setCurrentPos(props.performance.position);
    } else {
      if (playQueue) {
        if (settingsStore.getState().settings?.smartq_enabled && playQueue.items.length > 1) {
          setCurrentPos(-2);
        } else {
          setCurrentPos(playQueue.items.length - 1);
        }
      }
    }
  }, [playQueue]);

  useEffect(() => {
    let isManual = false;
    if (props.performance.flags) {
      if (props.performance.flags.includes("manual")) {
        isManual = true;
      }
    }
    if (currentPlayList) {
      setCurrentPos(currentPlayList.items.length);
    } else if (playQueue) {
      if (props.performance.position == 0 || isManual || !settingsStore.getState().settings?.smartq_enabled) {
        setCurrentPos(props.performance.position);
      } else {
        if (settingsStore.getState().settings?.smartq_enabled && playQueue.items.length > 1) {
          setCurrentPos(-2);
        } else {
          setCurrentPos(playQueue.items.length - 1);
        }
      }
    }
  }, [currentPlayList]);

  useEffect(() => {
    if (props.performance) {
      console.log(props.performance.position);
      setCurrentPos(props.performance.position);
    }
  }, [props.performance]);

  const handlePlayListChange = (event) => {
    let playListId = event.target.value;
    if (playListId == -1) {
      setCurrentPlayList(null);
      setIsSongbookQueue(false);
    } else if (playListId == -2) {
      setCurrentPlayList(null);
      setIsSongbookQueue(true);
    } else {
      let playList = playLists.find(x => x.id == playListId);
      if (playList) {
        if (!playList.items) {
          playList.items = [];
        }
        setCurrentPlayList(playList);
        setIsSongbookQueue(false);
      }
    }
  };

  const [isAddSingerOpen, setIsAddSingerOpen] = useState(false);

  const handleOpenAddSinger = () => {
    setIsAddSingerOpen(true);
  };

  const handleCloseAddSinger = () => {
    setIsAddSingerOpen(false);
  };

  const scrollToDown = () => {
    const dialogContainers = document.getElementsByClassName("MuiDialog-container");
    const textFields = document.getElementsByClassName("muvika-dialog-name");

    if (dialogContainers.length > 0 && textFields.length > 0) {
      for (let i = 0; i < dialogContainers.length; i++) {
        const container = dialogContainers[i];
        const textField = textFields[0];
        const offsetTop = textField.offsetTop - container.offsetTop;
        container.scrollTop = offsetTop;
      }
    }
  };


  useEffect(() => {
    let isManual = false;
    if (props.performance.flags) {
      if (props.performance.flags.includes("manual")) {
        isManual = true;
      }
    }
    if (props.open) {
      if (Capacitor.isNativePlatform()) {
        Keyboard.addListener('keyboardDidShow', info => {
          setTimeout(() => scrollToDown(), 100);
          Keyboard.removeAllListeners();
        });
      } else {
        setTimeout(() => scrollToDown(), 100);
      }
      setCurrentPlayList(null);
      setCurrentSinger(props.performance.profile);
      setCurrentSingerName(props.performance.profile.name);
      if (currentPlayList) {
        setCurrentPos(currentPlayList.items.length - 1);
      } else if (playQueue) {
        if (props.performance.position == 0 || isManual || !settingsStore.getState().settings?.smartq_enabled) {
          setCurrentPos(props.performance.position);
        } else {
          if (settingsStore.getState().settings?.smartq_enabled && playQueue.items.length > 1) {
            setCurrentPos(-2);
          } else {
            setCurrentPos(playQueue.items.length);
          }
        }
      }
    }
  }, [props.open]);

  useEffect(() => {
    setCurrentPitch(props.performance.pitch);
  }, [props.performance.pitch]);

  const handlePosChange = (event) => {
    let pos = event.target.value;
    console.log(pos);
    if (pos || pos == 0) {
      pos = parseInt(pos);
      if (pos != -1) {
        setCurrentPos(pos);
      }
    } else {
      pos = -1;
    }
    if (pos === -1) {
      handleOpenSelectSongPosition();
    }
  };

  const handleChoosePosition = (pos) => {
    if (pos || pos == 0) {
      if (currentPlayList) {
        if (pos >= currentPlayList.items.length) {
          setCurrentPos(currentPlayList.items.length);
        } else {
          setCurrentPos(pos);
        }
      } else {
        if (playQueue) {
          if (pos >= playQueue.items.length) {
            setCurrentPos(playQueue.items.length - 1);
          } else {
            setCurrentPos(pos);
          }
        }
      }
    }
    handleCloseSelectSongPosition();
  };

  const [creators, setCreators] = useState(null);

  const getCreators = () => {
    if (props.performance) {
      if (props.performance.track.track_id) {
        MuvikaService.getTrackCreators(sessionToken, props.performance.track.track_id)
          .then(function (res) {
            //console.log(res);
            if (res.data.data) {
              if (res.data.error) {
                setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              } else {
                setCreators(res.data.data.items);
              }
            }
          })
          .catch(function () { });
      }
    }
  };

  const [isCreatorsDialogOpen, setIsCreatorsDialogOpen] = useState(false);

  const handleOpenCreatorsDialog = () => {
    getCreators();
    setIsCreatorsDialogOpen(true);
  };

  const handleCloseCreatorsDialog = () => {
    setIsCreatorsDialogOpen(false);
  };

  const handleSingerSet = (event) => {
    let singerName = event.target.value;
    setCurrentSingerName(singerName);
  };

  const playNextButton = () => {
    console.log(currentPos);
    if (accountStore.getState().account && settings && !isSongbookQueue) {
      if (accountStore.getState().account.subscription.valid != 0 && !settings.hide_play_now) {
        return <Button color="success" onClick={() => {
          editPerformance(true);
        }}><span className="muvika-playnow-icon"><PlayArrowIcon /></span> {TR.cm_play_now}</Button>;
      }
    }
  };

  const singerList = () => {
    if (props.singers) {
      return props.singers.map((singer, index) =>
        <MenuItem key={singer.id} value={singer.id}>{singer.name}</MenuItem>
      );
    }
  };

  const playListList = () => {
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        if (playLists) {
          return playLists.map((playList) =>
            <MenuItem key={playList.id} value={playList.id}>{playList.name}</MenuItem>
          );
        }
      }
    }
  };

  const handleSingerChange = (event) => {
    if (props.singers) {
      let singerId = event.target.value;
      let singer = props.singers.find(x => x.id == singerId);
      if (singer) {
        setCurrentSinger(singer);
      }
    }
  };

  const handlePitchChange = (event, newPitch) => {
    setCurrentPitch(newPitch);
  };

  const renderMenuItemSongbookQueue = () => {
    if (isQueueingOn) {
      return <MenuItem value={-2}>{TR.cm_songbook_queue}</MenuItem>;
    }
  };

  const playListContainer = () => {
    if (playLists) {
      let val = -1;
      if (isSongbookQueue) val = -2;
      if (currentPlayList) val = currentPlayList.id;
      return <FormGroup>
        <InputLabel id="new-playlist-label">{TR.cm_playlist}</InputLabel>
        <Grid container spacing={0}>
          <Grid item xs={10.5}>
            <Select
              className="muvika-dialog-select"
              labelId="new-playlist-label"
              label="Playlist"
              value={val}
              onChange={handlePlayListChange}
            >
              <MenuItem value={-1}>{TR.cm_current_playqueue}</MenuItem>
              {renderMenuItemSongbookQueue()}
              {playListList()}
            </Select>
          </Grid>
          <Grid item xs={1.5}>
            {renderAddPlayListButton()}
          </Grid>
        </Grid>
      </FormGroup>;
    }
  };

  const renderChangeTrackButton = () => {
    if (props.onPerformanceToBeChanged) {
      return <Button variant="text" className="muvika-change-song-button" onClick={() => {
        props.onPerformanceToBeChanged();
        props.onClose();
      }}>{TR.cm_change_song}</Button>;
    }
  };

  const handlePlayListCreation = (playListName) => {
    if (playListName.length > 0) {
      setIsAddPlayListOpen(false);
      MuvikaService.createPlayList(sessionToken, playListName)
        .then(function (res) {
          if (res.data.error) {
            messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            performanceStore.getState().getPlayLists(sessionToken);
            let newPlayList = res.data.data;
            if (!newPlayList.items) {
              newPlayList.items = [];
            }
            setCurrentPlayList(newPlayList);
            setIsAddPlayListOpen(false);
          }
        });
    } else {
      setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
    }
  };

  const renderAddSingerButton = () => {
    if (settings) {
      if (settings.singer_selection === "list") {
        return <IconButton className="muvika-dialog-plus-button" color="white" component="label" onClick={handleOpenAddSinger}>
          <AddCircleIcon />
        </IconButton>;
      }
    }
  };

  const renderAddPlayListButton = () => {
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        return <IconButton className="muvika-dialog-plus-button" color="white" component="label" onClick={handleOpenAddPlayList}>
          <AddCircleIcon />
        </IconButton>;
      }
    }
  };

  const handleSingerCreation = (singerName, gender, email) => {
    if (singerName) {
      singerName = singerName.trim();
      if (singerName.length > 0) {
        setIsAddSingerOpen(false);
        MuvikaService.createSinger(sessionToken, singerName, gender, email)
          .then(function (res) {
            if (res.data.data) {
              addSingerLocally(res.data.data);
              if (res.data.data.id) {
                setCurrentSinger(res.data.data);
              } else {
                setError(sessionToken, 0, TR.cm_failed_to_create_singer);
              }
            }
          })
          .catch(function () { });
        setIsAddSingerOpen(false);
      } else {
        setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
      }
    } else {
      setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
    }
  };

  const editPerformance = (playNow = false) => {
    console.log("handleEdit 1");
    if (account) {
      if (settings.singer_selection === "type") {
        let singerName = currentSingerName;
        if (singerName) {
          singerName = singerName.trim();
          if (singerName.length > 0) {
            MuvikaService.createSinger(sessionToken, singerName, "", "")
              .then(function (res) {
                console.log("handleEdit 2");
                if (res.data.data) {
                  console.log("handleEdit 3");
                  addSingerLocally(res.data.data);
                  if (res.data.data.id) {
                    console.log("handleEdit 4");
                    let createdSinger = res.data.data;
                    if (res.data.error?.code === 2013 && singerName.toLowerCase() === res.data.data.name?.toLowerCase() && singerName !== res.data.data.name) {
                      console.log("handleEdit 5");
                      editSinger(sessionToken, createdSinger.id, singerName, createdSinger.gender, createdSinger.email);
                    }
                    console.log("handleEdit 6");
                    setCurrentSinger(createdSinger);
                    console.log("handleEdit t", playNow);
                    props.onEdit(createdSinger, currentPitch, playNow ? null : currentPlayList, playNow ? 0 : currentPos, playNow ? false : currentPos !== -2 && settingsStore.getState().settings?.smartq_enabled, playNow, isSongbookQueue);
                  } else {
                    setError(sessionToken, 0, TR.cm_failed_to_create_singer);
                  }
                }
              })
              .catch(function () { });
          } else {
            setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
          }
        } else {
          setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
        }
      } else {
        props.onEdit(currentSinger, currentPitch, playNow ? null : currentPlayList, playNow ? 0 : currentPos, playNow ? false : currentPos !== -2 && settingsStore.getState().settings?.smartq_enabled, playNow, isSongbookQueue);
      }
    }
  };


  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      if (isAddSingerOpen) {
        handleSingerCreation();
      } else if (isCreatorsDialogOpen) {
        handleCloseCreatorsDialog();
      } else if (isAddPlayListOpen) {
        handlePlayListCreation();
      } else {
        editPerformance();
      }
    }
  };

  const singerForm = () => {
    if (settings) {
      if (settings.singer_selection === "type") {
        return <FormGroup>
          <InputLabel>{TR.cm_singer}</InputLabel>
          <TextField
            size="small"
            inputRef={singerRef}
            className="muvika-dialog-name"
            margin="dense"
            type="email"
            fullWidth
            value={currentSingerName}
            onChange={handleSingerSet}
          />
        </FormGroup>;
      }
    }
    if (currentSinger) {
      return <FormGroup>
        <InputLabel id="new-singer-label">{TR.cm_singer}</InputLabel>
        <Grid container spacing={0}>
          <Grid item xs={10.5}>
            <Select
              className="muvika-dialog-select"
              labelId="new-singer-label"
              label={TR.cm_singer}
              value={currentSinger.id}
              onChange={handleSingerChange}
            >
              {singerList()}
            </Select>
          </Grid>
          <Grid item xs={1.5}>
            {renderAddSingerButton()}
          </Grid>
        </Grid>
      </FormGroup>;
    } else {
      if (props.singers?.length > 0) {
        return <FormGroup>
          <InputLabel id="new-singer-label">{TR.cm_singer}</InputLabel>
          <Grid container spacing={0}>
            <Grid item xs={10.5}>
              <Select
                className="muvika-dialog-select"
                labelId="new-singer-label"
                label={TR.cm_singer}
                value={props.singers[0].id}
                onChange={handleSingerChange}
              >
                {singerList()}
              </Select>
            </Grid>
            <Grid item xs={1.5}>
              {renderAddSingerButton()}
            </Grid>
          </Grid>
        </FormGroup>;
      } else {
        return <FormGroup>
          <InputLabel id="new-singer-label">{TR.cm_singer}</InputLabel>
          <Grid container spacing={0}>
            <Grid item xs={10.5}>
              <p className="muvika-no-singers">{TR.cm_no_singers}</p>
            </Grid>
            <Grid item xs={1.5}>
              {renderAddSingerButton()}
            </Grid>
          </Grid>
        </FormGroup>;
      }
    }
  };

  const renderPositionButtons = () => {
    if (settings && !isSongbookQueue) {
      let curPos = currentPos;
      if (currentPos || currentPos == 0) {
        if (curPos > 2) {
          curPos = -1;
        }
      }
      if (currentPlayList) {
        if (currentPos === currentPlayList.items.length) {
          curPos = currentPlayList.items.length;
        }
        return <Paper className="muvika-pos-buttons">
          <p className="muvika-pos-title">
            {TR.cm_performance_pos}
          </p>
          <PositionButtons
            value={curPos}
            performances={currentPlayList.items}
            onPosChange={handlePosChange}
            currentPosition={currentPos}
            isPlayQueue={false}
            isPlayList={true}
            isAdding={true}
            isSmartQ={settingsStore.getState().settings?.smartq_enabled}
          />
        </Paper>;
      } else if (playQueue) {
        if (currentPos === playQueue.items.length - 1 && !settingsStore.getState().settings?.smartq_enabled) {
          curPos = playQueue.items.length - 1;
        }
        return <Paper className="muvika-pos-buttons">
          <p className="muvika-pos-title">
            {TR.cm_performance_pos}
          </p>
          <PositionButtons
            value={curPos}
            performances={playQueue.items}
            onPosChange={handlePosChange}
            currentPosition={currentPos}
            isPlayQueue={true}
            isAdding={false}
            isSmartQ={settingsStore.getState().settings?.smartq_enabled}
          />
        </Paper>;
      }
    }
  };

  const renderSelectSongPosition = () => {
    let curSingerName = currentSinger ? currentSinger.name : null;
    if (settings) {
      if (settings.singer_selection === "type") {
        curSingerName = currentSingerName;
      }
    }
    if (currentPlayList) {
      return <SelectSongPosition
        open={isSelectSongPositionOpen}
        onClose={handleCloseSelectSongPosition}
        track={props.performance.track}
        currentSingerName={curSingerName}
        performances={currentPlayList.items}
        onChoosePosition={(pos) => {
          handleChoosePosition(pos);
        }}
      />;
    } else if (playQueue) {
      return <SelectSongPosition
        open={isSelectSongPositionOpen}
        track={props.track}
        currentSingerName={curSingerName}
        onClose={handleCloseSelectSongPosition}
        performances={playQueue.items}
        performance={props.performance}
        onChoosePosition={(pos) => {
          handleChoosePosition(pos);
        }}
      />;
    }
  };

  const handleSearchArtist = () => {
    props.onClose();
    setOnlyArtist();
    setSearchQuery(props.performance.track.artist);
    search(sessionToken, itemsOnPage);
    goToView(Views.Search);
  };

  const renderAddButton = () => {
    if (currentPlayList) {
      return <Button
        color="success"
        className="muvika-dialog-action-right"
        onClick={() => editPerformance()}>{TR.cm_add_to_list}</Button>;
    } else if (isSongbookQueue) {
      return <Button
        color="success"
        className="muvika-dialog-action-right"
        onClick={() => editPerformance()}>{TR.cm_add_to_queue}</Button>;
    } else {
      return <Button
        color="success"
        className="muvika-dialog-action-right"
        onClick={() => editPerformance()}>{TR.cm_save}</Button>;
    }
  };

  return (
    <BDialog openToLeft={true} disableRestoreFocus ref={dialogRef} open={props.open} onKeyDown={handleKeyDown} onClose={props.onClose} disableRestoreFocus>
      {renderSelectSongPosition()}
      <CreatorsDialog open={isCreatorsDialogOpen} onClose={handleCloseCreatorsDialog} creators={creators} track={props.performance.track} />
      <AddSinger open={isAddSingerOpen} isPerformanceAdd={true} onClose={handleCloseAddSinger} onSingerCreation={handleSingerCreation} />
      <AddPlayList
        open={isAddPlayListOpen}
        onClose={handleCloseAddPlayList}
        onPlayListCreation={handlePlayListCreation}
      />
      <DialogContent>
        <DialogPlayer track={props.performance.track} />
        <h4 className="muvika-track-title">
          <Link className="muvika-link-nodec" onClick={handleSearchArtist}>
            {props.performance.track.artist}
          </Link> - {props.performance.track.title} ({props.performance.track.kcode})
          <IconButton color="white" component="label" onClick={handleOpenCreatorsDialog}>
            <InfoIcon />
          </IconButton>
          {renderChangeTrackButton()}
        </h4>
        <Stack spacing={0}>
          {singerForm()}
          {playListContainer()}
          <Paper className="muvika-pitch-buttons">
            <p className="muvika-pitch-title">
              {TR.cm_key_pitch}
            </p>
            <PitchButtons value={currentPitch} onPitchChange={handlePitchChange} />
          </Paper>
          {renderPositionButtons()}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={4} justifyContent="center">
          <Button color="secondary" onClick={props.onClose}>{TR.cm_cancel}</Button>
          {renderAddButton()}
          {playNextButton()}
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default EditPerformance;